class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    // Com o mouse, o clique leva à coleção do item (o menu abre pelo hover); teclado continua abrindo/fechando
    this.summary.addEventListener('click', (event) => {
      if (!this.hoverQuery.matches || event.detail === 0) return;
      event.preventDefault();
      const href = this.summary.dataset.href;
      if (href) window.location.href = href;
    });
  }

  onMouseEnter() {
    if (!this.hoverQuery.matches) return;
    window.clearTimeout(this.hoverTimeout);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (!this.hoverQuery.matches) return;
    window.clearTimeout(this.hoverTimeout);
    this.hoverTimeout = window.setTimeout(() => this.close(), 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
